import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_progress = _resolveComponent("el-progress");
  const _component_vxe_modal = _resolveComponent("vxe-modal");
  return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_vxe_modal, {
    "model-value": _ctx.isShow,
    id: "myModal6",
    width: "340",
    onClose: _ctx.clickCloseMe,
    height: "90",
    "min-width": "260",
    "min-height": "300",
    "show-close": _ctx.data.isClose,
    lockView: false,
    mask: false,
    remember: "",
    storage: ""
  }, {
    title: _withCtx(() => _cache[0] || (_cache[0] = [_createElementVNode("span", {
      style: {
        "color": "red"
      }
    }, "SPU|SKU|暂存|保存 - 任务管理", -1)])),
    default: _withCtx(() => [_createVNode(_component_el_progress, {
      percentage: _ctx.data.progress,
      status: _ctx.data.isStatus,
      indeterminate: false
    }, null, 8, ["percentage", "status"])]),
    _: 1
  }, 8, ["model-value", "onClose", "show-close"])]);
}